interface IProps {
  quantity: number;
  onQuantityChanged: (quantity: number) => void;
}

function NumberOfCopiesSelector({ quantity, onQuantityChanged }: IProps) {
  function handleQuantityChanged(e: React.ChangeEvent<HTMLInputElement>) {
    onQuantityChanged(parseInt(e.target.value));
  }

  return (
    <tr>
      <th className="label">
        <label htmlFor="cq-pod-paper-size">
          Number of Copies <span color="red">*</span>
        </label>
        <span
          className="woo-selected-variation-item-name"
          data-default=""
        ></span>
      </th>
      <td className="value">
        <input
          type="number"
          name="cq-pod-quantity"
          value={quantity}
          onChange={handleQuantityChanged}
        />
      </td>
    </tr>
  );
}

export default NumberOfCopiesSelector;
